
document.addEventListener("DOMContentLoaded", function () {
  new Swiper('.ingredient-slider', {
    slidesPerView: 4.5,
    spaceBetween: 10,
    loop: true,
    grabCursor: true,

    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },

    speed: 600,

    navigation: {
      nextEl: '.ingredient-next',
      prevEl: '.ingredient-prev'
    },

    breakpoints: {
      1024: {
        slidesPerView: 4.5
      },
      768: {
        slidesPerView: 2
      },
      480: {
        slidesPerView: 1.3
      },
      0: {
        slidesPerView: 1.3
      }
    }
  });
});
 
 
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ingredient-inner').forEach((card) => {

    // CLICK ANYWHERE ON FRONT → OPEN
    card.querySelector('.ingredient-front').addEventListener('click', function () {
      card.classList.add('active');
    });

    // CLOSE ON BACK CLICK
    card.querySelector('.ingredient-back').addEventListener('click', function () {
      card.classList.remove('active');
    });

  });
});



